import types from './actionTypes';
import { ColorMode } from './reducer';

function setColorMode(mode: ColorMode) {
  return {
    type: types.SET_COLOR_MODE,
    mode,
  };
}

export default {
  setColorMode,
};
